<template>
  <div>
    <h4 class="font-weight-bold my-3"><v-icon icon="mdi-account-group" color="primary" size="xs-small"></v-icon> Mon
      Groupe</h4>
    <!-- <pre>{{ list_champs_formulaire.list }}</pre> -->

    <v-container>
      <v-row>
        <v-col>
          <p style="font-size: 1.1rem">Gagnez du temps, ces champs seront appliqués à tous les coureurs. Vous pourrez
            toujours les modifier ensuite.</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6" cols="12" class="py-0">
          <label class="field_label">Nom de mon groupe/club</label>
          <v-text-field v-model="mainStore.bookingSystem.groupe_default_fields.club" ref="field"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6" cols="12" class="py-0">
          <label class="field_label">Mail</label>
          <v-text-field v-model="mainStore.bookingSystem.groupe_default_fields.mail" ref="field"></v-text-field>
        </v-col>
        <v-col md="6" cols="12" class="py-0">
          <label class="field_label">Téléphone</label>
          <v-text-field v-model="mainStore.bookingSystem.groupe_default_fields.telephone" ref="field"></v-text-field>
        </v-col>
        <v-col md="6" cols="12" class="py-0">
          <label class="field_label">Code postal</label>
          <v-text-field v-model="mainStore.bookingSystem.groupe_default_fields.cp" ref="field"></v-text-field>
        </v-col>
        <v-col md="6" cols="12" class="py-0">
          <label class="field_label">Ville</label>
          <v-text-field v-model="mainStore.bookingSystem.groupe_default_fields.ville" ref="field"></v-text-field>
        </v-col>
        <v-col md="6" cols="12" class="py-0">
          <label class="field_label">Personne à contacter en cas d'urgence</label>
          <v-text-field v-model="mainStore.bookingSystem.groupe_default_fields.contact_urgence"
            ref="field"></v-text-field>
        </v-col>
        <v-col md="6" cols="12" class="py-0">
          <label class="field_label">Téléphone du contact d'urgence</label>
          <v-text-field v-model="mainStore.bookingSystem.groupe_default_fields.tel_contact_urgence"
            ref="field"></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
  components: {},
  data() {
    return {
      groupe_default_fields: {
        club: "",
        mail: "",
        telephone: "",
        cp: "",
        ville: "",
        contact_urgence: "",
        tel_contact_urgence: "",
      },
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  async created() {
    if (!this.mainStore.bookingSystem.groupe_default_fields) {
      this.mainStore.bookingSystem.groupe_default_fields = this.groupe_default_fields;
    }
  },
};
</script>

<style lang="scss" scoped>
.container_nom_groupe {
  width: 500px;
  max-width: 100%;
}
</style>